import Axios from 'axios';

const getHeaders = () => {
    const tokenType = localStorage.getItem('token_type');
    const accessToken = localStorage.getItem('access_token');

    // 检查tokenType和accessToken是否都存在
    if (!tokenType || !accessToken) {
        console.log("Token or Token Type is missing!");
        return "error";
    }

    const headers = {
        Authorization: `${tokenType} ${accessToken}`
    };
    return headers
}

export const importExcel = async (excelBlob) => {
    console.log('importExcel',localStorage)
    const url = process.env.REACT_APP_BACKEND_URL + '/upload_attendees';
    const tokenType = localStorage.getItem('token_type');
    const accessToken = localStorage.getItem('access_token');

    // 检查tokenType和accessToken是否都存在
    if (!tokenType || !accessToken) {
        console.log("Token or Token Type is missing!");
        return "error";
    }
    const formData = new FormData();
    formData.append('file', excelBlob);
    
    try {
        const response = await Axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${tokenType} ${accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.log(error.message);
        return "error";
    }
}

//export const sendEmail = async (idList) => {
//    const url = process.env.REACT_APP_BACKEND_URL + '/send-email'; 
//    const data = {
//        ids: idList
//    };

//    try {
//        const response = await Axios.post(url, data);
//        return response.data;
//    } catch (error) {
//        throw new Error(error.message);
//    }
//}

export const sendEmail = async (id) => {
    console.log('sendEmail',localStorage)
    const url = process.env.REACT_APP_BACKEND_URL + '/attendee/'+id+'/send_email'; 
    try {
        const response = await Axios.post(url, {}, {headers: getHeaders()});
        return response.data;
    } catch (error) {
        console.log(error.message);
        return "error";
    }
}

export const deleteEmail = async (id) => {
    console.log('deleteEmail',localStorage)
    const url = process.env.REACT_APP_BACKEND_URL + '/attendee/'+id; 
    try {
        const response = await Axios.delete(url, {headers: getHeaders()});
        return response.data;
    } catch (error) {
        console.log(error.message);
        return "error";
    }
}

export const editEmail = async (id, name, company, email, business_matching_meeting, last_modified) => {
    console.log('editEmail',localStorage)
    const url = process.env.REACT_APP_BACKEND_URL + '/attendee/'+id;
    const data = {
        attendee_id: id,
        full_name: name,
        company_name: company,
        email2: email,
        business_matching_meeting: business_matching_meeting,
        last_modified: last_modified,
    }
    try {
        const response = await Axios.patch(url, data, {headers: getHeaders()});
        return response.data;
    } catch(error) {
        console.log(error.message);
        return "error";
    }
}

export const editManage = async (id, name, uen_number, company, email, business_matching_meeting, mobile, remarks) => {
    console.log('editEmail',localStorage)
    const url = process.env.REACT_APP_BACKEND_URL + '/attendee/'+id;
    const data = {
        attendee_id: id,
        uen_number: uen_number,
        full_name: name,
        company_name: company,
        email2: email,
        business_matching_meeting: business_matching_meeting,
        mobile: mobile,
        remarks: remarks
    }
    try {
        const response = await Axios.patch(url, data, {headers: getHeaders()});
        return response.data;
    } catch(error) {
        console.log(error.message);
        return "error";
    }
}

export const createEmail = async (id, name, company, email, business_matching_meeting, last_modified) => {
    console.log('createEmail',localStorage)
    const url = process.env.REACT_APP_BACKEND_URL + '/attendee';
    const data = {
        attendee_id: id,
        full_name: name,
        company_name: company,
        email2: email,
        business_matching_meeting: business_matching_meeting,
        last_modified: last_modified,

        start_time:new Date().toISOString(),
        completion_time:new Date().toISOString(),
        email:"",
        name:"",
        UEN_number:"",
        desgination:"",
        contact_number:"",
        are_you_a_SME:"",
        are_you_a_local_company:"",
        business_sector:"",
        are_you_new_to_China_market:"",
        disclaimer:"",
    }
    try {
        const response = await Axios.post(url, data, {headers: getHeaders()});
        return response.data;
    } catch(error) {
        console.log(error.message);
        return "error";
    }
}

export const createManage = async (id, name, uen_number, company, email, business_matching_meeting, mobile, remarks) => {
    console.log('createEmail',localStorage)
    const url = process.env.REACT_APP_BACKEND_URL + '/attendee';
    const data = {
        attendee_id: id,
        uen_number: uen_number,
        full_name: name,
        company_name: company,
        email2: email,
        business_matching_meeting: business_matching_meeting,
        mobile: mobile,
        remarks: remarks
    }
    try {
        const response = await Axios.post(url, data, {headers: getHeaders()});
        return response.data;
    } catch(error) {
        console.log(error.message);
        return "error";
    }
}

export const loadEmail = async () => {
    console.log('loadEmail',localStorage)
    const url = process.env.REACT_APP_BACKEND_URL + '/attendee';
    try {
        const response = await Axios.get(url, {headers: getHeaders()});
        return response.data;
    } catch(error) {
        console.log(error.message);
        return "error";
    }
}

export const loadExcel = async () => {
    console.log('loadExcel',localStorage)
    const url = process.env.REACT_APP_BACKEND_URL + '/excel';
    try {
        const response = await Axios.get(url, {headers: getHeaders()});
        return response.data;
    } catch(error) {
        console.log(error.message);
        return "error";
    }
}

export const login = async (username, password) => {
    const url = process.env.REACT_APP_BACKEND_URL + '/token';
    const data = {
        username: username,
        password: password
    }
    try {
        const response = await Axios.post(url, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        console.log(response)
        if (response.data.access_token) {
            localStorage.setItem('access_token', response.data.access_token);
        }
        if (response.data.token_type) {
            localStorage.setItem('token_type', response.data.token_type);
        }
        console.log('login',localStorage)
        return response.data;
    } catch(error) {
        console.log(error.message);
        return "error";
    }
}